<template>
  <div class="kd-unsupported-device-warning" v-if="showWarning">
    <div class="kd-unsupported-device-warning__inner">
      <template v-if="showDisplayTooSmallWarning">
        <img :src="desktopIcon" class="kd-unsupported-device-warning__icon">
        <div class="kd-unsupported-device-warning__text">
          {{ screenTooSmallText }}
        </div>
      </template>
      <template v-if="showRotateWarning">
        <img :src="rotateIcon" class="kd-unsupported-device-warning__icon">
        <div class="kd-unsupported-device-warning__text kd-unsupported-device-warning__text--rotate">
          {{ rotateDeviceText }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import KdButton from '@/components/KdButton';

const NO_WARNING = 'NO_WARNING';
// shown when the device could be used if it was rotated
const ROTATE_DEVICE_WARNING = 'ROTATE_DEVICE_WARNING';
// shown when even rotating the device is not enough, because the screen is too small
const DISPLAY_TOO_SMALL_WARNING = 'DISPLAY_TOO_SMALL_WARNING';

const MINIMUM_SUPPORTED_WIDTH = 900;

export default {
  props: {
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      screenTooSmallText: "Das Display ihres Gerätes ist für die Verwendung des Grußkartendesigners leider zu klein. Bitte verwenden Sie einen Desktop-Computer. Wir bitten um Ihr Verständins.",
      rotateDeviceText: "Bitte drehen Sie Ihr Gerät",
      rotateIcon: require('../assets/images/icons/rotate-horizontal-blue.svg'),
      desktopIcon: require('../assets/images/icons/desktop-monitor-smiley-1.svg'),
    };
  },
  computed: {
    warningType() {
      // return NO_WARNING; // TODO: Delete, just for testing
      if (this.width < MINIMUM_SUPPORTED_WIDTH) {
        if (this.height > this.width && this.height >= MINIMUM_SUPPORTED_WIDTH) {
          return ROTATE_DEVICE_WARNING;
        }
        return DISPLAY_TOO_SMALL_WARNING;
      }
      // TODO: Browser check? If user is using IE11, we will not make it until here
      return NO_WARNING;
    },
    showWarning() {
      return this.warningType !== NO_WARNING;
    },
    showRotateWarning() {
      return this.warningType === ROTATE_DEVICE_WARNING;
    },
    showDisplayTooSmallWarning() {
      return this.warningType === DISPLAY_TOO_SMALL_WARNING;
    },
    // text() {
    //   if (this.rotateDevice) {
    //     return this.rotateDeviceText;
    //   }
    //   return this.notSupportedText;
    // },
  },
  components: {
    KdButton,
  },
};
</script>

<style lang="scss">
.kd-unsupported-device-warning {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F5F5F5;
}

.kd-unsupported-device-warning__text {
  padding: 20px;
  max-width: 450px;
  font-size: 1.3em;
  line-height: 1.3;

    &--rotate {
      text-align: center;
    }
 }

 .kd-unsupported-device-warning__icon {
  width: 150px;
  max-width: 40vw;
  margin-bottom: 14px;
  margin: 0 auto;
  margin-bottom: 20px;
 }
</style>
